import request from 'lmcv/utils/axios'
import { API_ENDPOINTS } from 'lmcv/modules/endpoints'

export const createProject = async (payload) => {
  const response = await request
    .post(
      API_ENDPOINTS.customers,
      payload
    )
    .then(({ data }) => data)
    .catch(err => { throw err.response })

  return response
}

export const sendInvite = async (payload) => {
  const response = await request
    .post(
      API_ENDPOINTS.customerInvite,
      payload
    )
    .then(({ data }) => data)
    .catch(err => { throw err.response })

  return response
}
